import {RASA_API, RASA_INTEGRATIONS_API, REQUEST, SWITCH} from './constants'
import {RequestAction, RequestOptions} from './types'

export const requestActionCreator =
  <Options extends RequestOptions>(prefix: string) =>
    (options: Options): RequestAction<Options> => ({type: `${prefix}_${REQUEST}`, options})

export const switchRequestActionCreator =
  <Options extends RequestOptions>(prefix: string) =>
  (options: Options): RequestAction<Options> => ({type: `${SWITCH}_${prefix}_${REQUEST}`, options})

export const apiRequestActionCreator =
  <Options extends RequestOptions>(prefix: string) =>
    (options: Options): RequestAction<Options> => ({type: `${prefix}_${RASA_API}_${REQUEST}`, options})

export const integrationsRequestActionCreator =
<Options extends RequestOptions>(prefix: string) =>
  (options: Options): RequestAction<Options> => ({type: `${prefix}_${RASA_INTEGRATIONS_API}_${REQUEST}`, options})

export type CommunityDataFetcher = (communityIdentifier: string) => RequestAction

export const communityDataFetchAction = (action: string, url: string): CommunityDataFetcher =>
  (communityIdentifier: string) =>
  requestActionCreator(action)
  ({url: `${url}/${communityIdentifier}`, method: 'GET'})



// WEBPACK FOOTER //
// ./src/request/actions.ts